<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findBusinessIntranetMemberList.action"
                    ref="intranetBusinessMemberManagementTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">

            <el-form-item>
              <el-input placeholder="搜索姓名/手机号/商家名称" v-model="queryParams.keyword"></el-input>
            </el-form-item>

              <el-form-item>
                <el-select  @change="$refs.intranetBusinessMemberManagementTable.search()" clearable placeholder="会员类型"
                            v-model="queryParams.type">

                  <el-option :value="3" label="卖车通会员"></el-option>
                  <el-option :value="5" label="买卖通会员"></el-option>
                  <el-option :value="6" label="专享通会员"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item >
              <el-date-picker
                  @change="onDateTimeChange(queryParams.registerStartEndTime,1)"
                  end-placeholder="注册结束日期"
                  range-separator="至"
                  start-placeholder="注册开始日期"
                  type="datetimerange"
                  v-model="queryParams.registerStartEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item >
              <el-date-picker
                  @change="onDateTimeChange(queryParams.startEndTime,2)"
                  end-placeholder="付款结束日期"
                  range-separator="至"
                  start-placeholder="付款开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker v-model="queryParams.memberEndTimeAr" start-placeholder="到期开始时间" end-placeholder="到期结束时间"
                              type="datetimerange" @change="onMemberEndTimeChange">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.intranetBusinessMemberManagementTable.search()" type="primary">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.push('/home/businessMemberItem')" type="primary">开通会员</el-button>
            </el-form-item>

          </el-form>
        </el-row>
      </template>
      <template slot="item">
        <el-table-column
            label="会员信息"
            prop="">
          <template scope="scope">
            {{scope.row.memberName}}-{{scope.row.memberPhone}}
          </template>
        </el-table-column>

        <el-table-column
            label="商家名称"
            prop="businessName">
        </el-table-column>
        <el-table-column
            label="邀请人信息"
            prop="">
          <template scope="scope">
            {{scope.row.inviterEmployeeName}}-{{scope.row.inviterEmployeePhone}}
          </template>
        </el-table-column>
        <el-table-column
            label="会员注册时间"
            prop="">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="会员类型">
          <template scope="scope">
            {{scope.row.memberType|memberTypeFilter}}
          </template>

        </el-table-column>
        <el-table-column
            label="会员到期时间"
            prop="">
          <template scope="scope">
            {{scope.row.endTime|dateTimeFormat}}
          </template>
        </el-table-column>

        <el-table-column
            label="累计付款次数(次)"
            prop="paySuccessCount">
        </el-table-column>
        <el-table-column
            label="累计付款金额(元)"
            prop="paySuccessTotalMoney">
        </el-table-column>
        <el-table-column
            label="最近付款时间"
            prop="">
          <template scope="scope">
            {{scope.row.lastPayTime|dateTimeFormat}}
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetBusinessMemberManagement',
  data: function () {
    return {
      queryParams: {
        startEndTime: null,
        registerStartEndTime: null,
        memberStartTime: null,
        memberEndTime: null
      }
    }
  },
  methods: {
    onMemberEndTimeChange: function () {
      let memberEndTimeAr = this.queryParams.memberEndTimeAr
      if (memberEndTimeAr && memberEndTimeAr[0]) {
        this.queryParams.memberStartTime = memberEndTimeAr[0].getTime()
        this.queryParams.memberEndTime = memberEndTimeAr[1].getTime()
      } else {
        this.queryParams.memberStartTime = null
        this.queryParams.memberEndTime = null
      }
      this.$refs.intranetBusinessMemberManagementTable.search()
    },
    onDateTimeChange (dates, type) {
      if (type === 1) {
        if (dates && dates.length === 2) {
          this.queryParams.registerStartTime = dates[0].getTime()
          this.queryParams.registerEndTime = dates[1].getTime()
        } else {
          this.queryParams.registerStartTime = null
          this.queryParams.registerEndTime = null
        }
      }
      if (type === 2) {
        if (dates && dates.length === 2) {
          this.queryParams.startPayTime = dates[0].getTime()
          this.queryParams.endPayTime = dates[1].getTime()
        } else {
          this.queryParams.startPayTime = null
          this.queryParams.endPayTime = null
        }
      }
      this.$refs.intranetBusinessMemberManagementTable.search()
    }
  },
  filters: {
    memberTypeFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '普通用户'
          break
        case 2:
          str = '卖车通365会员'
          break
        case 3:
          str = '卖车通会员'
          break
        case 4:
          str = '收车通会员'
          break
        case 5:
          str = '买卖通会员'
          break
        case 6:
          str = '专享通会员'
          break
        default:
          str = '普通用户'
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
